import { render, staticRenderFns } from "./newMaterial.vue?vue&type=template&id=4ba32763&scoped=true&"
import script from "./newMaterial.vue?vue&type=script&lang=js&"
export * from "./newMaterial.vue?vue&type=script&lang=js&"
import style0 from "./newMaterial.vue?vue&type=style&index=0&id=4ba32763&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba32763",
  null
  
)

export default component.exports